export default {
	api: 'https://ust-testing.beautitag.com/cso/api',
	loginTimeout: 86400
};
